
import React from 'react';

interface CustomTooltipProps {
  active?: boolean;
  payload?: any[];
  label?: any;
  chartType: 'price' | 'discount' | 'cost' | 'volume';
  currentMargin: number;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
  chartType,
  currentMargin
}) => {
  if (!active || !payload || !payload.length) {
    return null;
  }

  const marginValue = payload[0].value;
  const changeValue = label;
  let changeLabel = '';
  
  switch (chartType) {
    case 'price':
      changeLabel = `Price change: ${changeValue > 0 ? '+' : ''}${changeValue}%`;
      break;
    case 'discount':
      // For discount chart, the label now shows the absolute discount rate rather than a change
      changeLabel = `Discount rate: ${changeValue}%`;
      break;
    case 'cost':
      changeLabel = `Cost change: ${changeValue > 0 ? '+' : ''}${changeValue}%`;
      break;
    case 'volume':
      changeLabel = `Volume change: ${changeValue > 0 ? '+' : ''}${changeValue}%`;
      break;
    default:
      changeLabel = `Change: ${changeValue}%`;
  }
  
  return (
    <div 
      className="bg-[#111827] p-2 border border-gray-700 rounded shadow-md text-white" 
      style={{
        fontSize: '10px',
        position: 'absolute',
        top: '-75px',
        left: '70%',
        width: "148px",
        height: "90px",
        transform: 'translateX(140%)',
        pointerEvents: 'none',
        zIndex: 1000
      }}
    >
      <p className="font-medium mb-1">{changeLabel}</p>
      <p className="text-[#94a3b8]">
        Simulated margin: <span className="text-white font-medium">{marginValue.toFixed(2)}%</span>
      </p>
      <div className="mt-2 pt-2 border-t border-gray-700">
        <p className="text-[#94a3b8]">
          Current margin: <span className="text-[#10B981] font-medium">{currentMargin.toFixed(2)}%</span>
        </p>
      </div>
    </div>
  );
};

export default CustomTooltip;
